import { render, staticRenderFns } from "./StrugglePicker.vue?vue&type=template&id=2eafab38&"
import script from "./StrugglePicker.vue?vue&type=script&lang=js&"
export * from "./StrugglePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports